<template>
  <div>
    <b-modal
      title="DETALHES DA VENDA"
      id="sale"
      size="lg"
      hide-footer
      no-close-on-backdrop
    >
      <details-sale :sale="sale" />
    </b-modal>
    <b-modal
      title="DEFINIR VALOR DO MEDICAMENTO"
      id="edit_item_value"
      size="md"
      hide-footer
      no-close-on-backdrop
    >
      <edit-item-value
        :stock_item_id="stock_item_id"
        @success="handleSuccessEditItemValue"
      />
    </b-modal>
    <tab-content-layout title="">
      <template #top-right-button>
        <v-btn v-if="step == 'paginate'" @click="handleNewSale" class="btn-add">
          <i class="fas fa-plus mr-2 text-twenty"></i> NOVA VENDA
        </v-btn>
        <confirmation-dialog
          v-if="step == 'create'"
          message-title="CANCELAR?"
          message-body="Deseja realmente cancelar o cadastro?"
          open-class="btn-cancel"
          open-left-icon="fa-times"
          open-text="CANCELAR"
          @yes="handlePaginate"
        />
      </template>
      <div v-show="step == 'create'" class="v-clean pl-2 pr-2">
        <div class="row m-0">
          <div class="col-md-12 pt-0 pb-0">
            <h4 class="title-pages">EMPRESA</h4>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pt-0 pb-0">
            <v-select-default
              disabled
              item-text="name"
              item-value="id"
              :items="stock_item_types"
              label="TIPO"
              v-model="rest_home_stock_item_type_id"
              @change="handleFilterRestHome"
            />
          </div>
          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pt-0 pb-0">
            <v-select-default
              item-text="name"
              item-value="id"
              :items="groups"
              label="GRUPO"
              v-model="rest_home_stock_group_id"
              @change="handleFilterRestHome"
            />
          </div>
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0">
            <v-text-field-default
              label="BUSCAR"
              v-model="search_rest_home_stocked_items"
            />
          </div>
          <div class="col-md-12 pt-0 pb-0">
            <b-overlay :show="loadingItemsRestHome" opacity="0.99">
              <div
                v-show="rest_home_stock_items.length === 0"
                class="col-12 v-clean p-5"
              >
                <h6 class="text-center upper-text worksansr">
                  SEM RESULTADOS!
                </h6>
              </div>
              <v-data-table
                :search="search_rest_home_stocked_items"
                v-show="rest_home_stock_items.length > 0"
                dense
                showSelect
                singleSelect
                :headers="rest_home_stock_items_headers"
                :items="rest_home_stock_items"
                v-model="rest_home_stock_item"
                :footer-props="{
                  'items-per-page-options': [10, 25, 50, 100],
                  'items-per-page-text': 'Mostrar',
                }"
              >
                <template v-slot:[`item.stock_item_name`]="{ item }">
                  {{ item.product_name }}
                </template>
                <template v-slot:[`item.amount`]="{ item }">
                  {{ item.amount }}
                  {{ item.stock_item_unit_of_measurement_abbreviation }}
                </template>
                <template #[`item.lot`]="{ item }">
                  {{ item.lot }}
                </template>
                <template #[`item.entry_date`]="{ item }">
                  {{ moment(item.entry_date).format("DD/MM/YYYY") }}
                </template>
                <template #[`item.due_date`]="{ item }">
                  {{
                    item.due_date
                      ? moment(item.due_date).format("DD/MM/YYYY")
                      : "NÃO INFORMADO"
                  }}
                </template>
              </v-data-table>
            </b-overlay>
          </div>
          <div class="col-md-12">
            <v-text-field-default
              disabled
              type="text"
              label="PRODUTO"
              :value="
                rest_home_stock_item.length > 0
                  ? rest_home_stock_item[0].product_name
                  : 'NÃO INFORMADO'
              "
            />
          </div>
          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
            <v-select-default
              item-text="name"
              item-value="id"
              :items="stock_groups"
              label="GRUPO"
              v-model="stock_group_id"
            />
          </div>
          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
            <v-text-field-default
              type="date"
              label="VENCIMENTO*"
              v-model="due_date"
            />
          </div>
          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
            <v-text-field-default type="text" label="LOTE" v-model="lot" />
          </div>
          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
            <v-text-field-default
              type="text"
              label="DESCRIÇÃO"
              v-model="description"
            />
          </div>
          <div class="col-md-12 pt-0 pb-0">
            <stock-item-price-list
              :stock_item="item"
              @value="handleValueStockItemPriceList"
              @type="handleTypeStockItemPriceList"
            />
            <div class="mt-2 v-warning p-2" v-if="invalid_stock_item_price">
              <h6 class="m-0">
                PRODUTO NÃO POSSUI VALOR DE VENDA DEFINIDO NO SEU CADASTRO!
              </h6>
              <p class="m-0">
                POR FAVOR, INFORME PARA QUE POSSA REALIZAR A VENDA.
              </p>
              <v-btn
                @click="handleEditItemValue"
                v-if="permission('edit', 'medicine')"
                small
                >DEFINIR VALOR</v-btn
              >
            </div>
            <div
              class="mt-2 v-warning p-2"
              v-if="
                readjustment == 'REAJUSTE_VALOR_MEDIO' &&
                show_alert_stock_item_price
              "
            >
              <h6 class="m-0">
                PRODUTO NÃO POSSUI VALOR DE VENDA DEFINIDO NO SEU CADASTRO!
              </h6>
              <p class="m-0">POR FAVOR, ALTERE PARA REAJUSTE MANUAL.</p>
              <v-btn
                @click="handleEditItemValue"
                v-if="permission('edit', 'medicine')"
                small
                >DEFINIR VALOR</v-btn
              >
            </div>
            <div
              class="mt-2 v-warning p-2"
              v-if="
                readjustment == 'REAJUSTE_MAIOR_VALOR' &&
                show_alert_stock_item_price
              "
            >
              <h6 class="m-0">
                PRODUTO NÃO POSSUI VALOR DE VENDA DEFINIDO NO SEU CADASTRO!
              </h6>
              <p class="m-0">POR FAVOR, ALTERE PARA REAJUSTE MANUAL.</p>
              <v-btn
                @click="handleEditItemValue"
                v-if="permission('edit', 'medicine')"
                small
                >DEFINIR VALOR</v-btn
              >
            </div>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
            <v-text-field-default
              :disabled="!value"
              type="number"
              :label="`${
                rest_home_stock_item.length > 0
                  ? rest_home_stock_item[0]
                      .stock_item_unit_of_measurement_abbreviation
                  : 'QUANTIDADE'
              }*`"
              v-model="amount"
              @input="handleInputAmount"
            />
          </div>
          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
            <v-text-field-default
              :disabled="true"
              type="text"
              label="VALOR"
              v-model="value"
              @input="handleInputValue"
            />
          </div>
          <div class="col-md-12 pt-0 pb-0">
            <warning-required-fields class="pt-3" />
          </div>
          <div class="col-md-12 pt-0 pb-0">
            <h4 class="title-pages">RESIDENTE</h4>
          </div>
          <div class="col-md-12 pt-0 pb-0">
            <v-select-default
              item-text="name"
              item-value="id"
              :items="residents"
              label="RESIDENTE"
              v-model="resident_id"
              required
            />
          </div>
          <div class="col-md-12 pt-0 pb-0">
            <errors-messages :errors="errors" />
          </div>
          <div class="col-md-12 text-right">
            <confirmation-dialog
              v-if="step == 'create'"
              message-title="CANCELAR?"
              message-body="Deseja realmente cancelar o cadastro?"
              open-class="btn-cancel"
              open-left-icon="fa-times"
              open-text="CANCELAR"
              @yes="handlePaginate"
            />
            <v-btn-save
              class="ml-2"
              :disabled="btnExecuteDisabled"
              :loading="loading"
              text="EXECUTAR"
              @click="execute"
            />
          </div>
        </div>
      </div>
      <div v-show="step == 'paginate'" class="v-clean mt-2">
        <div class="row m-0">
          <div class="col-md-12 pb-0"><errors-messages :errors="errors" /></div>
          <div class="col-md-12 pt-0">
            <v-select-default
              item-text="name"
              item-value="id"
              :items="residents"
              label="RESIDENTE"
              v-model="filter_resident_id"
              @change="paginate"
            />
          </div>
        </div>
        <b-overlay :show="loadingPaginate" opacity="0.99">
          <div v-show="sales.length == 0" class="m-2 v-clean p-5">
            <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
          </div>
          <div v-show="sales.length > 0">
            <errors-messages :errors="errors" />
          </div>
          <v-data-table
            v-show="sales.length > 0"
            dense
            :headers="headers"
            :items="sales"
            :footer-props="{
              'items-per-page-options': [50, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
            :options.sync="options"
            :server-items-length="total"
          >
            <template v-slot:[`item.status`]="{ item }">
              <div v-if="item.status == 0 || item.status == 2">
                <span>FATURADO</span>
                <v-icon class="ml-2" small color="success">
                  mdi-check-circle-outline
                </v-icon>
              </div>
              <div v-if="item.status == 1">
                <span>FATURAMENTO PENDENTE</span>
                <v-icon class="ml-2" small color="orange">
                  mdi-information-outline
                </v-icon>
              </div>
              <div v-if="item.status == 3">
                <span>PAGO</span>
                <v-icon class="ml-2" small color="success"
                  >mdi-check-circle-outline</v-icon
                >
              </div>
            </template>
            <template v-slot:[`item.amount`]="{ item }">
              {{ item.amount }}
              {{ item.stock_item_unit_of_measurement_abbreviation }}
            </template>
            <template v-slot:[`item.value`]="{ item }">
              {{ formatReal(String(item.value)) }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <confirmation-dialog
                v-if="item.reversal && item.status == 1"
                :disabled="loadingReverse"
                :loading="loadingReverse"
                x_small
                message-title="ESTORNAR?"
                message-body="Deseja realmente estornar a venda?"
                open-class="btn-delete m-1"
                open-left-icon="fa-history"
                open-text="ESTORNAR"
                @yes="reverse(item.id)"
              />
              <v-btn
                x-small
                class="btn-edit m-1"
                @click="handleDetailsSale(item)"
              >
                <i class="fas fa-eye mr-2"></i>DETALHES
              </v-btn>
            </template>
            <template v-slot:[`item.created_at`]="{ item }">
              {{ moment(item.created_at).format("DD/MM/YYYY HH:mm:ss") }}
            </template>
          </v-data-table>
        </b-overlay>
      </div>
    </tab-content-layout>
  </div>
</template>

<script>
import TabContentLayout from "../../../Components/TabContentLayout.vue";
import VSelectDefault from "../../../Components/VSelectDefault.vue";
import VTextFieldDefault from "../../../Components/VTextFieldDefault.vue";
import VBtnSave from "../../../Components/VBtnSave.vue";
import ErrorsMessages from "../../../Components/ErrorsMessages.vue";
import WarningRequiredFields from "../../../Components/WarningRequiredFields.vue";
import ConfirmationDialog from "../../../Components/ConfirmationDialog.vue";

import DetailsSale from "../details.vue";

import EditItemValue from "./edit-item-value.vue";

import StockItemPriceList from "../../movement/purchase/sale-stock-item-price-list.vue";

import api from "../../../../services/api";

import APIGet from "../../../../lib/api-get";

import toast from "../../../../lib/ToastNotification";

import {
  formatReal,
  formatValueOnKeyUp,
  numbersOnly,
} from "../../../../lib/format";

import moment from "moment";

import permission from "../../../../lib/permission";

export default {
  name: "Product",

  components: {
    TabContentLayout,
    VSelectDefault,
    VTextFieldDefault,
    VBtnSave,
    ErrorsMessages,
    WarningRequiredFields,
    ConfirmationDialog,
    DetailsSale,
    StockItemPriceList,
    EditItemValue,
  },

  created() {
    this.retrieve();
  },

  data() {
    return {
      search_rest_home_stocked_items: "",
      step: "paginate",

      filter_resident_id: "",

      total: 0,
      options: {},
      headers: [
        { text: "STATUS", value: "status", sortable: false },
        { text: "PRODUTO", value: "item_name", sortable: false },
        { text: "RESIDENTE", value: "resident_name", sortable: false },
        { text: "GRUPO", value: "stock_group_name", sortable: false },
        { text: "LOTE", value: "lot", sortable: false },
        { text: "QTD", value: "amount", sortable: false },
        { text: "R$", value: "value", sortable: false },
        { text: "DT/VENDA", value: "created_at", sortable: false },
        { text: "AÇÕES", value: "actions", sortable: false },
      ],

      sales: [],
      sale: {},

      residents: [],
      stock_groups: [],
      stock_item_types: [],
      rest_home_stock_items: [],

      rest_home_stock_item: [],

      item: {},
      stock_item_price_list: null,

      stock_items_headers: [{ text: "NOME", value: "name", sortable: false }],
      rest_home_stock_items_headers: [
        { text: "NOME", value: "stock_item_name" },
        { text: "GRUPO", value: "stock_group_name" },
        { text: "QUANTIDADE", value: "amount" },
        { text: "LOTE", value: "lot" },
        { text: "DT/ENTRADA", value: "entry_date" },
        { text: "DT/VENCIMENTO", value: "due_date" },
      ],

      resident_id: "",
      stock_item_id: "",
      stock_item_type_id: "",

      rest_home_stock_item_type_id: "",
      rest_home_stock_group_id: "",

      stock_group_id: "",
      amount: "",
      due_date: "",
      lot: "",
      description: "",
      value: "",

      errors: [],

      value_manual: false,

      readjustment: null,

      show_alert_stock_item_price: false,
      invalid_stock_item_price: false,

      loading: false,
      loadingItems: false,
      loadingItemsRestHome: false,
      loadingPaginate: false,
      loadingReverse: false,
    };
  },

  computed: {
    groups() {
      return [{ id: "", name: "TODOS" }, ...this.stock_groups];
    },

    btnExecuteDisabled() {
      let {
        loading,
        rest_home_stock_item,
        amount,
        stock_group_id,
        value,
        invalid_stock_item_price,
      } = this;

      if (invalid_stock_item_price) return true;
      if (loading) return true;
      if (!amount) return true;
      if (!stock_group_id) return true;
      if (!value) return true;

      if (rest_home_stock_item.length > 0) {
        let item = rest_home_stock_item[0];

        let rest_home_amount = item.amount;

        amount = String(amount).replace(",", ".");
        rest_home_amount = String(rest_home_amount).replace(",", ".");

        if (parseFloat(amount) > parseFloat(rest_home_amount)) {
          return true;
        }
      }

      return false;
    },
  },

  watch: {
    options: {
      handler() {
        this.paginate();
      },
    },

    rest_home_stock_item() {
      if (this.rest_home_stock_item.length > 0) {
        let item = this.rest_home_stock_item[0];

        this.stock_item_id = item.stock_item_id;

        this.lot = item.lot;
        this.due_date = item.due_date
          ? moment(item.due_date).format("YYYY-MM-DD")
          : "";
        this.description = item.description;
        this.amount = item.amount;

        this.handleModalVerifyStockItemPriceList();
      } else {
        this.item = {};
        this.lot = "";
        this.due_date = "";
        this.description = "";
        this.amount = "";
        this.value = "";
      }
    },
  },

  methods: {
    moment,
    formatReal,
    permission,

    handleEditItemValue() {
      this.$bvModal.show("edit_item_value");
    },

    handleSuccessEditItemValue() {
      this.$bvModal.hide("edit_item_value");
      this.item = {};
      this.handleModalVerifyStockItemPriceList();
    },

    handleTypeStockItemPriceList(data) {
      let { readjustment, stock_item } = data;

      this.value_manual = false;
      this.invalid_stock_item_price = false;
      this.show_alert_stock_item_price = false;
      this.readjustment = readjustment;

      let { type } = stock_item;

      if (type == "PRODUCT") {
        let { product_sale } = stock_item;
        if (!product_sale) {
          this.invalid_stock_item_price = true;
        } else {
          if (parseFloat(product_sale) <= 0) {
            this.invalid_stock_item_price = true;
          }
        }
      }
    },

    async handleValueStockItemPriceList(data) {
      let { value } = data;

      if (value == "0,00") {
        value = null;
      }

      this.value = value;
      this.stock_item_price_list = data;

      this.handleInputAmount(this.amount);
    },

    handleInputAmount(amount) {
      let { stock_item_price_list, value } = this;

      if (amount) {
        amount = String(amount).replace(",", ".");

        if (value) {
          if (stock_item_price_list) {
            this.value = formatValueOnKeyUp(
              String(
                parseFloat(amount) *
                  parseFloat(numbersOnly(stock_item_price_list.value))
              )
            );
          } else {
            this.value = stock_item_price_list.value;
          }
        }
      } else {
        if (stock_item_price_list) {
          this.value = stock_item_price_list.value;
        }
      }
    },

    handleModalVerifyStockItemPriceList() {
      let { rest_home_stock_item } = this;
      if (rest_home_stock_item.length > 0) {
        let item = rest_home_stock_item[0];
        this.item = { ...item, amount: item.stock_item_size };
      }
    },

    handleInputValue(value) {
      this.value = formatValueOnKeyUp(value);
    },

    handleNewSale() {
      this.errors = [];

      this.rest_home_stock_item = [];
      this.amount = "";
      this.due_date = "";
      this.lot = "";
      this.description = "";
      this.stock_group_id = "";
      this.value = "";

      this.step = "create";
      this.handleStep("create");
    },

    handlePaginate() {
      this.errors = [];

      this.step = "paginate";
      this.handleStep("paginate");
    },

    handleStep(step) {
      let { menu, tipo, venda, acao } = this.$router.currentRoute.query;

      if (step != acao) {
        this.$router.replace({ query: { menu, tipo, venda, acao: step } });
      }

      this.step = step;
    },

    handleDetailsSale(sale) {
      this.sale = sale;
      this.$bvModal.show("sale");
    },

    handleFilterRestHome() {
      this.getItemsByRestHome();

      this.rest_home_stock_item = [];
      this.amount = "";
      this.due_date = "";
      this.lot = "";
      this.description = "";
      this.stock_group_id = "";
      this.value = "";
    },

    async getItemsByRestHome() {
      try {
        this.loadingItemsRestHome = true;

        const { rest_home_stock_item_type_id, rest_home_stock_group_id } = this;

        let params = {
          resident_id: null,
          stock_group_id: rest_home_stock_group_id,
          stock_item_type_id: rest_home_stock_item_type_id,
        };

        const response = await APIGet.getStockedItems(params);

        const { errors, stocked_items } = response;

        this.errors = errors;

        this.rest_home_stock_items = stocked_items;
        this.loadingItemsRestHome = false;
      } catch (error) {
        console.log(error);
      }
    },

    async retrieve() {
      await this.getTypes();
      await this.getResidents();
      await this.getStockGroups();
      await this.getItemsByRestHome();
      await this.paginate();

      let { menu, tipo, venda, acao } = this.$router.currentRoute.query;

      if (!acao) {
        this.$router.replace({
          query: { menu, tipo, venda, acao: "paginate" },
        });
        this.step = "paginate";
      } else {
        if (["paginate", "create"].includes(acao)) {
          this.step = acao;
        } else {
          this.step = "paginate";
        }
      }
    },

    async paginate() {
      try {
        this.loadingPaginate = true;

        let { filter_resident_id } = this;

        const { page, itemsPerPage } = this.options;

        let params = {
          resident_id: filter_resident_id,
          page,
          itemsPerPage,
          type: "PRODUCT",
        };

        let response = await api.get("/rest-home/stock/sales", {
          params,
        });

        let { error, errors, sales, total } = response.data;

        if (!error) {
          this.sales = sales;
          this.total = total;
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loadingPaginate = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getTypes() {
      try {
        let params = { type: "PRODUCT" };

        const response = await APIGet.getStockItemTypes(params);

        const { error, errors, stock_item_types } = response;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          if (stock_item_types.length > 0) {
            this.stock_item_types = stock_item_types;
            this.stock_item_type_id = stock_item_types[0].id;
            this.rest_home_stock_item_type_id = stock_item_types[0].id;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getResidents() {
      try {
        const response = await api.get("/rest-home/residents");

        const { error, errors, residents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.residents = [{ id: "", name: "SELECIONE..." }, ...residents];
        }
      } catch (error) {
        console.error(error);
      }
    },

    async getStockGroups() {
      try {
        let params = { type: "PRODUCT" };

        const response = await APIGet.getStockGroups(params);

        const { error, errors, stock_groups } = response;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.stock_groups = stock_groups;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async execute() {
      try {
        this.loading = true;

        let {
          resident_id,
          rest_home_stock_item,
          amount,
          due_date,
          lot,
          description,
          stock_group_id,
          value,
        } = this;

        if (rest_home_stock_item.length == 0) {
          this.errors = ["Informe o produto da EMPRESA"];
          return;
        }

        let stocked_item_id = rest_home_stock_item[0].id;
        let stock_item_id = rest_home_stock_item[0].stock_item_id;

        let data = {
          resident_id,
          amount,
          stocked_item_id,
          stock_item_id,
          due_date,
          lot,
          description,
          stock_group_id,
          value,
          type: "PRODUCT",
        };

        const response = await api.post("/rest-home/stock/sale", data);

        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");

          this.rest_home_stock_item = [];
          this.amount = "";
          this.due_date = "";
          this.lot = "";
          this.description = "";
          this.stock_group_id = "";
          this.value = "";

          this.getItemsByRestHome();
          this.paginate();

          this.handleStep("paginate");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async reverse(id) {
      try {
        this.loadingReverse = true;

        let data = { id };

        const response = await api.post("/rest-home/stock/sale-reverse", data);

        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.getItemsByRestHome();
          this.paginate();
          this.handleStep("paginate");
        }

        this.loadingReverse = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>